import { getCexLabel } from "@cede/utils";
import { UseTutorialsHook } from "./types";
import { useQuery } from "@tanstack/react-query";

const fetchTutorial = async (cexId: string): Promise<string> => {
  const response = await fetch(`/tutorials/api-keys/${cexId}/${cexId}.md`);
  if (!response.ok) {
    throw new Error("Failed to load MD file");
  }
  return response.text();
};

export const useTutorials: UseTutorialsHook = (cexId: string) => {
  const { data: mdContent, isLoading } = useQuery({
    queryKey: ["tutorial", cexId],
    queryFn: () => fetchTutorial(cexId),
    retry: false,
    staleTime: Infinity,
  });

  return {
    tutorialType: "api-keys/" + cexId.toLowerCase(),
    mdContent: mdContent ?? "",
    cex: { value: cexId, label: getCexLabel(cexId) },
    isLoading,
  };
};
